import CrudAPIClient from '../crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { MetaQuery } from '@refinedev/core';
import { axiosInstance } from '../axios';

const parseBundleId = (value: unknown): number | null => {
  const normalized = String(value ?? '').trim();
  if (!normalized) return null;

  const bundleId = Number(normalized);
  return Number.isFinite(bundleId) && bundleId > 0 ? bundleId : null;
};

export default class StyleBundleRemoveAPIClient extends CrudAPIClient {
  constructor() {
    super(GATEWAY_API_URL + '/catalog/product/stylebundle/remove');
  }

  async search(query: any, page: number, size: number): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async create(payload: any): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async updateById(id: any, data: any): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async findBulk(ids: any[]): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async findById(id: any): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async createMany(payload: any[], meta: MetaQuery | undefined): Promise<any> {
    try {
      const bundles = payload.map(bundle => ({
        bundleId: parseBundleId(bundle.bundleId),
      }));

      const response = await axiosInstance.post(`${this.baseURL}`, { bundles });
      return this.transformList(response.data.data);
    } catch (error) {
      console.error(`Error removing style bundles in bulk:`, error);
      throw error;
    }
  }
}
